import { useQuery } from '@tanstack/react-query';
import { ContractDateToUse, PartnershipInformation, RexApiContext } from '@urbanx/agx.rex.client';
import { useContext } from 'react';

export const useLoadPartnershipInfo = (
  shouldLoad: boolean,
  thisYear: boolean
): {
  partnershipInfo: PartnershipInformation | undefined;
  isPending: boolean;
  isError: boolean;
} => {
  const rexApi = useContext(RexApiContext);

  const {
    data: partnershipInfoResponse,
    isPending,
    isError,
  } = useQuery<PartnershipInformation | undefined>({
    queryKey: ['getPartnershipInformation', thisYear],
    queryFn: () =>
      rexApi.getPartnershipInformation({
        thisYear,
        contractDateToUse: ContractDateToUse.Settled,
      }),
    enabled: shouldLoad,
  });

  return {
    partnershipInfo: partnershipInfoResponse,
    isPending,
    isError,
  };
};
